import React from 'react';
import styles from "../app.module.scss";

export const FooterBar = () => {
  return (
      <div className={styles.footerBar}>
        Copyright © 2003-{(new Date()).getFullYear()} Torparängens Samfällighetsforeningen i 16244 Stockholm (Vällingby).
      </div>
  );
}
